/* ORIAVI performance loader — scroll-snap core only when the component exists. */
(() => {
  const currentScript = document.currentScript;
  const currentSrc = currentScript && currentScript.src;
  if (!currentSrc) return;

  const coreUrl = new URL(currentSrc, window.location.href);
  coreUrl.pathname = coreUrl.pathname.replace(/modules-basis\.js$/, 'modules-basis-core.js');
  coreUrl.search = '';
  const coreSrc = coreUrl.toString();
  let loadPromise;

  const loadCore = () => {
    if (loadPromise) return loadPromise;
    loadPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-oriavi-modules-basis-core]');
      if (existing) {
        if (existing.dataset.loaded === 'true') resolve();
        else {
          existing.addEventListener('load', resolve, { once: true });
          existing.addEventListener('error', reject, { once: true });
        }
        return;
      }

      const script = document.createElement('script');
      script.src = coreSrc;
      script.async = false;
      script.dataset.oriaviModulesBasisCore = 'true';
      script.addEventListener('load', () => {
        script.dataset.loaded = 'true';
        resolve();
      }, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });
    return loadPromise;
  };

  const hasComponent = (root = document) => {
    if (!root || typeof root.querySelector !== 'function') return false;
    return Boolean(root.querySelector('[is="scroll-snap-slider"], scroll-snap-slider'));
  };

  const loadIfNeeded = (root = document) => {
    if (hasComponent(root) || (root !== document && hasComponent(document))) loadCore();
  };

  window.oriaviLoadScrollSnapCore = loadCore;
  loadIfNeeded();

  document.addEventListener('shopify:section:load', (event) => {
    loadIfNeeded(event.target || document);
  });
})();
